import { render, staticRenderFns } from "./PromptCookieConsent.vue?vue&type=template&id=135d2c56&scoped=true"
import script from "./PromptCookieConsent.vue?vue&type=script&lang=js"
export * from "./PromptCookieConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d2c56",
  null
  
)

export default component.exports